import { render } from "./DashboardWinnersMap.vue?vue&type=template&id=20d1ef59"
import script from "./DashboardWinnersMap.vue?vue&type=script&lang=js"
export * from "./DashboardWinnersMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__